module.exports = __webpack_public_path__ + "images/spring-sale-bg-mobile.jpg";